import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import { Dropdown, Button } from 'antd';
import { useState, useMemo } from 'react';
import classNames from 'classnames';
import { ga_logEvent } from '@/shared/ga';
import { EventName, EventNameSource } from '@/shared/event-types';
import Image from 'next/image';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useAddAccountModal } from '@/context/AddAccountModalProvider';
const isValidUrl = (string: string) => {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
};
const iconUrlMap1 = new Map([
  [
    'onlyfans.com',
    {
      url: 'https://www.onlyfans.com/',
      icon: '/images/erasa/platforms/onlyfans.png',
    },
  ],
  [
    'tiktok.com',
    {
      url: 'https://www.tiktok.com/@',
      icon: '/images/erasa/platforms/tiktok.png',
    },
  ],
  ['x.com', { url: 'https://x.com/', icon: '/images/erasa/platforms/space.png' }],
  [
    'instagram.com',
    {
      url: 'https://www.instagram.com/',
      icon: '/images/erasa/platforms/ins.png',
    },
  ],
  [
    'patreon.com',
    {
      url: 'https://www.patreon.com/',
      icon: '/images/erasa/platforms/patreon.png',
    },
  ],
  [
    'chaturbate.com',
    {
      url: 'https://www.chaturbate.com/',
      icon: '/images/erasa/platforms/chaturbate.png',
    },
  ],
  [
    'fansly.com',
    {
      url: 'https://www.fansly.com/',
      icon: '/images/erasa/platforms/fansly.png',
    },
  ],
  [
    'fanvue.com',
    {
      url: 'https://www.fanvue.com/',
      icon: '/images/erasa/platforms/fanvue.png',
    },
  ],
  [
    'manyvids.com',
    {
      url: 'https://www.manyvids.com/',
      icon: '/images/erasa/platforms/manyvids.png',
    },
  ],
  [
    'reddit.com',
    {
      url: 'https://www.reddit.com/',
      icon: '/images/erasa/platforms/reddit.png',
    },
  ],
  [
    'pornhub.com',
    {
      url: 'https://www.pornhub.com/',
      icon: '/images/erasa/platforms/pornhub.png',
    },
  ],
  [
    'fansone.co',
    {
      url: 'https://fansone.co/',
      icon: '/images/erasa/platforms/fansone.png',
    },
  ],
]);

const iconUrlMap2 = new Map([['other', { url: 'Add Account', icon: '/images/erasa/platforms/other.png' }]]);

const Index = ({
  getAccount,
  pageSource,
  useNewModal,
}: {
  getAccount: (inputValue: string, selectedPlatform: string) => void;
  pageSource: EventNameSource;
  useNewModal?: boolean;
}) => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState('Add Account');
  const [inputValue, setInputValue] = useState('');
  const [isVaild, setIsVaild] = useState(true);
  const [vaildMessage, setVaildMessage] = useState('');
  const [step, setStep] = useState(1);
  const isMobile = useIsMobile();
  const { openAddAccountModal } = useAddAccountModal();

  const imgUrl = useMemo(() => {
    if (selectedPlatform == 'other') {
      return iconUrlMap2.get(selectedPlatform)?.icon;
    } else {
      return iconUrlMap1.get(selectedPlatform)?.icon;
    }
  }, [selectedPlatform]);

  const handleAddAccount = () => {
    if (selectedPlatform == 'Add Account') {
      setIsVaild(false);
      setVaildMessage(t('Please select a platform'));
      return;
    }
    if (!inputValue) {
      setIsVaild(false);
      setVaildMessage(t('Please enter a valid username'));
      return;
    }
    setIsVaild(true);
    getAccount(inputValue, iconUrlMap1.get(selectedPlatform)?.url);
    ga_logEvent(EventName.input_account_handle, { page_source: pageSource });
  };

  const DropdownMenu = () => {
    return (
      <div className={styles.platforms}>
        <div>{t('Subscription Platforms')}</div>
        <ul className={styles.ul}>
          {Array.from(iconUrlMap1.keys()).map((item) => (
            <li
              key={item}
              onClick={() => {
                if (useNewModal) {
                  return;
                }
                setSelectedPlatform(item);
                setOpen(false);
                setStep(2);
              }}
            >
              <img src={iconUrlMap1.get(item)?.icon} alt={item} />
              <div>{item}</div>
            </li>
          ))}
        </ul>
        <div>{t('Other Platforms')}</div>
        <ul className={styles.ul1}>
          {Array.from(iconUrlMap2.keys()).map((item) => (
            <li
              key={item}
              onClick={() => {
                if (useNewModal) {
                  return;
                }
                setSelectedPlatform(item);
                setOpen(false);
                setStep(2);
              }}
            >
              <img src={iconUrlMap2.get(item)?.icon} alt={item} />
              <div>{item}</div>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  const handleBlur = () => {
    if (selectedPlatform == 'other') {
      return;
    }
    if (isValidUrl(inputValue)) {
      const urlObk = new URL(inputValue);
      const regex = /^(?:https?:\/\/)?(?:www\.)?([^\/]+)/;
      const match = urlObk.hostname.match(regex);
      const domain = match ? match[1] : null;
      setSelectedPlatform(domain);
      if (domain == 'tiktok.com') {
        const pathname = urlObk.pathname.slice(2);
        setInputValue(pathname);
      } else {
        const pathname = urlObk.pathname.slice(1);
        setInputValue(pathname);
      }
    }
  };
  return (
    <div className={styles.main}>
      <div className={styles.wrapper}>
        <div
          className={classNames({
            [styles.container1]: step == 1,
            [styles.activeContainer1]: step == 2,
            [styles.clickable]: useNewModal,
          })}
          onClick={() => {
            if (useNewModal) {
              openAddAccountModal(pageSource);
            }
          }}
        >
          <div className={styles.container}>
            <div className={styles.step0} style={{ display: step == 1 ? 'flex' : 'none' }}>
              <Dropdown
                dropdownRender={() => DropdownMenu()}
                trigger={useNewModal ? [] : ['click']}
                autoAdjustOverflow={false}
                open={useNewModal ? false : open}
                onOpenChange={useNewModal ? undefined : setOpen}
                placement={isMobile ? 'top' : undefined}
              >
                <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                  <Image
                    src="/images/home/platforms.webp"
                    alt="platforms"
                    width={24}
                    height={24}
                    priority
                    className={styles.img}
                    onClick={() => {
                      if (useNewModal) {
                        return;
                      }
                      setOpen(true);
                      ga_logEvent(EventName.select_platform, { page_source: pageSource });
                    }}
                  />
                  <span className={styles.addAccount}>{t('Add Account')}</span>
                </div>
              </Dropdown>
            </div>
            <div className={styles.step2} style={{ display: step == 2 ? 'flex' : 'none' }}>
              <img src={imgUrl} className={styles.img1} alt="platforms" />
              <input
                required
                type="text"
                name="text"
                placeholder={selectedPlatform == 'other' ? 'https://example.com' : 'e.g.username (without symbol)'}
                autoComplete="off"
                value={inputValue}
                onChange={(e) => {
                  if (useNewModal) {
                    return;
                  }
                  setInputValue(e.target.value);
                }}
                className={styles.input}
                onBlur={() => {
                  if (useNewModal) {
                    return;
                  }
                  handleBlur();
                }}
                onKeyDown={(e) => {
                  if (useNewModal) {
                    return;
                  }
                  if (e.key === 'Enter') {
                    handleAddAccount();
                  }
                }}
                readOnly={useNewModal}
              />
            </div>
            <label
              className={classNames(styles.label, {
                [styles.label2]: step == 2,
              })}
            >
              {selectedPlatform}
            </label>
            <div
              className={styles.error}
              style={{ display: step == 2 ? 'flex' : 'none' }}
              onClick={() => {
                if (useNewModal) {
                  return;
                }
                setIsVaild(true);
                setVaildMessage('');
                setSelectedPlatform('Add Account');
                setInputValue('');
                setStep(1);
              }}
            >
              x
            </div>
          </div>
        </div>
        <div className={styles.btn}>
          <Button
            onClick={() => {
              if (useNewModal) {
                openAddAccountModal(pageSource);
                return;
              }
              handleAddAccount();
              ga_logEvent(EventName.click_add_account);
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.5 12.5C22.5 6.97688 18.0231 2.5 12.5 2.5C6.97688 2.5 2.5 6.97688 2.5 12.5C2.5 18.0231 6.97688 22.5 12.5 22.5C18.0231 22.5 22.5 18.0231 22.5 12.5ZM12.0288 13.8681H11C8 13.8681 7.14875 15.7087 7.14875 15C7.14875 14.2912 8 11.3006 11.5 11.3006H12.0288V8.69438L17.78 12.585L12.0288 16.4756V13.8681Z"
                fill="white"
              />
            </svg>
            <span>{t('Get Started Free')}</span>
          </Button>
        </div>
      </div>
      {vaildMessage && (
        <div style={{ height: '20px' }} className={styles.vaildMessageContainer}>
          <div className={styles.vaildMessage} style={{ color: isVaild ? '#e0e0e0' : '#ff4d4f' }}>
            {vaildMessage}
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
